// extracted by mini-css-extract-plugin
export default {"MerchantLink":"MerchantsList_MerchantLink__nGclv","MerchantTitle":"MerchantsList_MerchantTitle__-vrt6","DisabledBadge":"MerchantsList_DisabledBadge__7qL0-"};